import React, {Component} from 'react';
import { responsiveFontSize, responsiveHeight, responsiveWidth } from '../Services/Utilities';

class AddBlockTitle extends Component {
    constructor(props){
        super(props)

    }

    render(){
        return(
            <div style = {{
                display:'inline-block',
                marginBottom: responsiveHeight(0.5), flexDirection:'row',display:'flex', width:'100%', alignItems:'center', alignContent:'center'}} 
            className = { !this.props.Selected ? "" : "border-bottom border-info"}>
                     <h6 style = {{color: this.props.Selected ? '#0489B1' : 'black',
                         fontWeight:'bold', textAlign:'center', alignSelf:'center', fontSize: responsiveFontSize(0.9)}}>{this.props.text}</h6>
                    {this.props.Verified ? 
                    <h6 style = {{color:'green', fontWeight:'bold', textAlign:'center', alignSelf:'center', fontSize: responsiveFontSize(0.9), marginLeft: responsiveWidth(1)}}>✔</h6> : <div />}
            </div>
        )
    }
}

export default AddBlockTitle